// extracted by mini-css-extract-plugin
module.exports = {"content-container":"Tooltip_content-container__x_QMG","content":"Tooltip_content__6BhWM","trigger":"Tooltip_trigger__dfYEd"};